<template>
  <div>
    <!----><div v-if="!getFormProps.form_submitted" style="margin-top: -50px; width: 100%; display: flex; flex-direction: column; justify-content: flex-start; align-items: flex-start;">

        <div style="margin-top: 20px;width: 100%; display: flex; flex-direction: column; justify-content: center; align-items: center;">
            <span style="font-size: 24px; font-weight: 500;">
                Please fillup this form
            </span>
            <span style="font-size: 14px; font-weight: 500;" 
            v-html="$store.getters.getVisitorGeographyDetail.response_time_message">
                
            </span>
        </div>
        
        <Form 
            @closed="$emit('closed')" 
            style="margin-top: 20px; text-align: left; width: 100%; display: flex; flex-direction: column; justify-content: flex-start; align-items: flex-start;"/>
        
    </div>
    <div v-else style="margin-top: -50px; width: 100%; display: flex; flex-direction: column; justify-content: flex-start; align-items: flex-start;">

        <div style="margin-top: 20px;width: 100%; display: flex; flex-direction: column; justify-content: center; align-items: center;">
            <span style="font-size: 24px; font-weight: 500;">
                Thank You!!!
            </span>
            <span style="font-size: 14px; font-weight: 500;" 
            v-html="getFormProps.form_submitted_message">
                
            </span>
        </div>
    </div>
  </div>
</template>

<script>
import Form from './Form.vue'

export default {
    components: {Form},
    computed: {
      getFormProps() {
          return this.$store.state.master.props
      }
    },
    mounted() {
      this.$store.state.master.props.form_submitted = false
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/SignUp/Index.vue